import * as React from 'react'
import { useLoaderData } from 'react-router-dom'

import { Divider } from 'sdk'
import { Content } from 'sdk/components'

import { NewsSection } from './components/news-section/NewsSection'
import { HomePageLoaderData } from './interfaces'
import { Hero } from './sections/hero/Hero'
import { AccelerationSection } from './sections/acceleration/AccelerationSection'
import { BottomHeroSection } from './sections/bottom-hero/BottomHeroSection'
import { PartnerProgramFeatureSection } from './sections/partner-program/PartnerProgramFeatureSection'
import { SoundcoreSection } from './sections/soundcore/SoundcoreSection'
import { SoundscapeSection } from './sections/soundscape/SoundscapeSection'
import { TechBenefitsSection } from './sections/tech-benefits/TechBenefitsSection'

export const HomePage: React.FC = () => {
  const { newsfeed, cmsContent } = useLoaderData() as HomePageLoaderData

  if (!cmsContent) {
    throw new Error('Home CMS content missing')
  }

  return (
    <>
      <Hero content={cmsContent.hero} />
      <Content gap={150}>
        <NewsSection items={newsfeed} />
        <AccelerationSection content={cmsContent.acceleration} />
        <Divider />
        <SoundcoreSection content={cmsContent.soundcore} />
        <SoundscapeSection content={cmsContent.soundscape} />
        <Divider />
        <PartnerProgramFeatureSection content={cmsContent.partnerProgram} />
        <TechBenefitsSection content={cmsContent.technologyBenefits} />
      </Content>
      <BottomHeroSection
        title={
          <>
            {cmsContent.bottomHero.titleLine1}
            {cmsContent.bottomHero.titleLine2 ? (
              <>
                <br /> {cmsContent.bottomHero.titleLine2}
              </>
            ) : null}
          </>
        }
        description={cmsContent.bottomHero.description}
        buttonText={cmsContent.bottomHero.buttonText}
        buttonHref={cmsContent.bottomHero.buttonUrl}
      />
    </>
  )
}
